'use client';

import { useEffect, type MouseEvent } from 'react';
import Button, { ButtonVariants } from '@pixum/button';
import { useCartStore } from 'stores/cart';
import { trackOpenOrder, trackPaynowClick } from '../../../analytics/overview';
import type { PayNowButtonProps } from './types';

export function PayNowButton({ paymentGatewayUrl, label }: PayNowButtonProps) {
  const isBusy = useCartStore(state => state.isBusy);

  useEffect(() => {
    trackOpenOrder();
  }, []);

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (isBusy) {
      e.preventDefault();

      return;
    }

    trackPaynowClick();
  };

  return (
    <Button
      data-action="pay-again"
      data-testid="product-pay-again"
      variant={ButtonVariants.STRONG}
      disabled={!paymentGatewayUrl}
      isBusy={isBusy}
      href={paymentGatewayUrl}
      onClick={paymentGatewayUrl ? handleClick : undefined}
      aria-disabled={!paymentGatewayUrl || isBusy}
      aria-busy={isBusy}
      tabIndex={!paymentGatewayUrl ? -1 : undefined}
    >
      {label}
    </Button>
  );
}
